<template>
  <HeaderComp />
  <div class="home" style="overflow: hidden">
    <BannerComp />
    <AssetComp />
    <ContactComp />
    <FooterComp />
  </div>
</template>

<script>
// @ is an alias to /src
import "../assets/styles/style.css";
import HeaderComp from "@/components/template/HeaderComp.vue";
import BannerComp from "@/components/home/BannerComp.vue";
import AssetComp from "@/components/template/AssetComp.vue";
import ContactComp from "@/components/template/ContactComp.vue";
import FooterComp from "@/components/template/FooterComp.vue";

export default {
  name: "HomeView",
  components: {
    HeaderComp,
    BannerComp,
    AssetComp,
    ContactComp,
    FooterComp,
  },
};
</script>
